import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Tooltip, makeStyles, Fab } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { downloadAttachment } from 'reducers/FileReducer'
// import { setCircularLoading } from 'reducers/ui/UiMenuReducer';

const useStyles = makeStyles((theme) => ({
  fabStyle: {
    backgroundColor: theme.palette.colors.chipBg,
    color: 'secondary',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

const DownloadAttachments = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { disabled = false, tooltipText = 'Download', children } = props;
  const selectedDownloadAttachments = useSelector(
    (state) => state.attachments.selectedDownloadAttachments
  );

  const handleMutipleDownload = async () => {
    // dispatch(setCircularLoading(true));
    try {
      for (const att of selectedDownloadAttachments) {
        try {
          await downloadAttachment(att.ptsAttachmentId, att.name);
        } catch (err) {
          console.log('Download failed:', err);
        }
      }
    } finally {
    //   dispatch(setCircularLoading(false));
    }
  };

  return (
    <>
      <Tooltip title={tooltipText}>
        <Fab
            disabled={disabled}
            style={{ marginLeft: '10px' }}
            size="small"
            color="secondary"
            aria-label="citation download"
            className={classes.fabStyle ? classes.fabStyle : ''}>
            <DownloadIcon onClick={handleMutipleDownload} />
        </Fab>
      </Tooltip>
      {children}
    </>
  );
};

export default DownloadAttachments;
